import React from "react";
import { useTranslation } from "react-i18next";
import { NumberInput } from "../../common/NumberInput";

export function NutritionSection({ protein, carbs, fat, setField }) {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-3 gap-4 mt-2">
      <NumberInput
        label={t("protein")}
        name="protein"
        value={protein}
        placeholder={t("protein")}
        onChange={e => setField("protein", e.target.value)}
        min={0}
      />
      <NumberInput
        label={t("carbs")}
        name="carbs"
        value={carbs}
        placeholder={t("carbs")}
        onChange={e => setField("carbs", e.target.value)}
        min={0}
      />
      <NumberInput
        label={t("fat")}
        name="fat"
        value={fat}
        placeholder={t("fat")}
        onChange={e => setField("fat", e.target.value)}
        min={0}
      />
    </div>
  );
}